import { Component, inject } from '@angular/core';
import { LoginFormController } from '../../../../helpers/user/login-form-controller';
import { SocialAuthLink } from '../../../../../../environments/environment';
import { GoogleTagManagerService } from '../../../../services/google-tag-manager.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { BreakpointsDetectorService } from 'src/app/core/services/breakpoints-detector.service';
import { TranslatePipe } from '../../../translation/translate.pipe';
import { RouterLinkDirective } from '../../../directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { RestrictSignupService } from '../../../../services/restrict-signup.service';


@Component({
    selector: 'app-header-login-form',
    templateUrl: './header-login-form.component.html',
    styleUrls: ['./header-login-form.component.scss'],
    imports: [RouterLink, RouterLinkDirective, TranslatePipe]
})
export class HeaderLoginFormComponent {
  private _gtm = inject(GoogleTagManagerService);
  user = inject(UserService);
  breakpoints = inject(BreakpointsDetectorService);
  restrictSignUp = inject(RestrictSignupService)


  /**
   * Controller for current login form
   */
  public controller: LoginFormController = new LoginFormController();

  get Link() { return SocialAuthLink; }

  onLoginClick() {
    this._gtm.signInHeaderClick('login_header', 'header');
  }

  onRegisterClick() {
    this._gtm.registerHeaderClick('register_header', 'header_menu');
  }
}
